export default __webpack_public_path__ + "static/media/career-fullimage-placeholder.7e959c3f.jpg";